import { Button, Col, Dropdown, Input, Row } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Shoutout = ({ data, setData, handleCancel, handleNext, errors, setErrors }) => {
  const { t } = useTranslation();

  const reason = [
    {
      value: t('requestShoutout.birthday'),
      option: 'Birthday'
    },
    {
      value: t('requestShoutout.anniversary'),
      option: 'Anniversary'
    },
    {
      value: t('requestShoutout.motivational'),
      option: 'Motivational'
    },
    {
      value: t('requestShoutout.mentorship'),
      option: 'Mentorship'
    },
    {
      value: t('editProfile.other'),
      option: 'Other'
    }
  ];
  const gender = [
    {
      value: t('editProfile.male'),
      option: 'male'
    },
    {
      value: t('editProfile.female'),
      option: 'female'
    },
    {
      value: t('editProfile.other'),
      option: 'other'
    }
  ];

  const [formData, setFormData] = useState({
    reqName: '',
    introduction: '',
    gender: '',
    instructions: '',
    addInstruction: ''
  });

  useEffect(() => {
    if (data) {
      setFormData({
        reqName: data.reqName || '',
        introduction: data.introduction || '',
        gender: data.gender || '',
        instructions: data.instructions || '',
        addInstruction: data.addInstruction || ''
      });
    }
  }, [data]);
  function handleClosedChange() {
    setErrors([]);
    setFormData({
      reqName: '',
      introduction: '',
      gender: '',
      instructions: '',
      addInstruction: ''
    });
    handleCancel();
  }
  function handleChange() {
    setErrors([]);

    const errorList = [];
    // Validation checks
    if (!formData.reqName) errorList.push({ input: 'reqName', err: 'Required.' });
    if (formData.reqName.length > 18)
      errorList.push({ input: 'reqName', err: t('maximum18Chars') });

    if (formData.addInstruction.length > 200)
      errorList.push({ input: 'addInstruction', err: t('maximum200Chars') });

    if (!formData.instructions) errorList.push({ input: 'instructions', err: 'Required.' });

    if (!formData.introduction) errorList.push({ input: 'introduction', err: 'Required.' });
    if (formData.introduction.length > 200)
      errorList.push({ input: 'introduction', err: t('maximum200Chars') });

    if (errorList.length > 0) {
      return setErrors(errorList); // Exit early if there are validation errors
    }

    setData((data1) => ({
      ...data1,
      ...formData
    }));

    handleNext(); // Only call handleNext if there are no validation errors
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleDropDownChange = (inputEl, value) => {
    setFormData({
      ...formData,
      [inputEl]: value
    });
  };

  return (
    <Col wid="100%" marg="8px 0 0" center between>
      <Col marg="0 0 0" wid="100%" center>
        <Col marg="16px 0 0" wid="100%">
          <Input
            name="reqName"
            error={errors.find((x) => x.input === 'reqName')?.err}
            title={t('requestShoutout.whatIsYourName')}
            value={formData.reqName}
            placeholder={t('requestShoutout.maximum18Chars')}
            shoutout
            maxLength="18"
            onChange={handleInputChange}
          />
        </Col>
        <Col marg="16px 0 0" wid="100%">
          <Input
            marg="0 0 24px"
            multiline
            ht="160px"
            id="introduction"
            name="introduction"
            error={errors.find((x) => x.input === 'introduction')?.err}
            title={t('requestShoutout.introduction')}
            placeholder={t('requestShoutout.maximum200Chars')}
            value={formData.introduction}
            shoutout
            maxLength="200"
            onChange={handleInputChange}
          />
        </Col>

        <Col marg="10px 0 0" wid="100%">
          <Dropdown
            title={t('requestShoutout.selectOcassion')}
            options={reason}
            name="instructions"
            error={errors.find((x) => x.input === 'instructions')?.err}
            selected={formData.instructions}
            handleSelect={(value) => {
              handleDropDownChange('instructions', value);
            }}
            bg="#fff"
            rounded
            wid="100%"
          />
        </Col>

        <Col marg="10px 0 0" wid="100%">
          <Dropdown
            title={t('requestShoutout.gender')}
            options={gender}
            selected={formData.gender}
            name="gender"
            error={errors.find((x) => x.input === 'gender')?.err}
            handleSelect={(value) => {
              handleDropDownChange('gender', value);
            }}
            bg="#fff"
            rounded
            wid="100%"
          />
        </Col>

        <Col marg="16px 0 0" wid="100%">
          <Input
            marg="0 0 24px"
            multiline
            ht="160px"
            id="addInstruction"
            name="addInstruction"
            error={errors.find((x) => x.input === 'addInstruction')?.err}
            title={t('requestShoutout.addInstruction')}
            placeholder={t('requestShoutout.maximum200Chars')}
            value={formData.addInstruction}
            shoutout
            maxLength="200"
            onChange={handleInputChange}
          />
        </Col>

        <Row marg="16px 0 0" between wid="100%" gap="10px" display="column">
          <Button
            onClick={handleChange}
            app
            bg={theme.SECONDARY}
            pad="9px 24px"
            text={t('common.save')}
          />

          <Button
            onClick={handleClosedChange}
            app
            bg={theme.GREY_60}
            pad="9px 24px"
            marg="10px 0 0"
            text={t('yourRequests.cancel')}
          />
        </Row>
      </Col>
    </Col>
  );
};

export default Shoutout;
